/**
 * Supplier Domain - Data Transformations
 * Hanterar transformering av leverantörsdata för API-anrop
 */

/**
 * Förbereder leverantörsdata för backend (create)
 * @param {Object} values - Formulärets värden
 * @param {Array} discounts - Specifika rabatter
 * @returns {Object} Data redo för backend
 */
export const prepareSupplierDataForCreate = (values, discounts) => {
  const data = {
    supplierType: values.supplierType,
    companyName: values.companyName,
    website: values.website,
    // Enkel kontaktperson utan användarkonto
    contactPerson: values.contactPerson || '',
    email: values.email || '',
    phone: values.phone || '',
    discountRate: values.discountRate,
    discountDescription: values.discountDescription,
    contactMethod: values.contactMethod,
    discounts: discounts.filter(d => d.category.trim() !== '' && d.rate !== ''),
    showInBrief: values.showInBrief !== false,
    showInOffers: values.showInOffers !== false
  };

  if (values.contactMethod === 'affiliate' && values.affiliateUrl) {
    data.affiliateUrl = values.affiliateUrl;
  }

  if (values.primaryContactPerson) {
    data.primaryContactPerson = values.primaryContactPerson;
  }

  return data;
};

/**
 * Förbereder leverantörsdata för backend (update)
 * @param {Object} values - Formulärets värden
 * @param {Array} discounts - Specifika rabatter
 * @returns {Object} Data redo för backend
 */
export const prepareSupplierDataForUpdate = (values, discounts) => {
  return {
    supplierType: values.supplierType,
    companyName: values.companyName,
    website: values.website,
    contactPerson: values.contactPerson || '',
    email: values.email || '',
    phone: values.phone || '',
    discountRate: values.discountRate !== '' ? Number(values.discountRate) : 0,
    discountDescription: values.discountDescription,
    discounts: discounts.filter(d => d.category.trim() !== '' && d.rate !== '').map(d => ({
      ...d,
      rate: Number(d.rate)
    })),
    removeAvatar: values.removeAvatar,
    contactMethod: values.contactMethod,
    affiliateUrl: values.contactMethod === 'affiliate' ? values.affiliateUrl : null,
    primaryContactPerson: values.primaryContactPerson || null,
    showInBrief: values.showInBrief !== false,
    showInOffers: values.showInOffers !== false
  };
};

/**
 * Konverterar leverantörsdata till FormData
 * @param {Object} supplierData - Leverantörsdata
 * @param {File} avatarFile - Avatar-fil (optional)
 * @returns {FormData}
 */
export const convertToFormData = (supplierData, avatarFile = null) => {
  const formData = new FormData();
  
  Object.entries(supplierData).forEach(([key, value]) => {
    if (key === 'discounts') {
      formData.append(key, JSON.stringify(value));
    } else if (key === 'removeAvatar') {
      formData.append(key, value ? 'true' : 'false');
    } else if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });
  
  if (avatarFile) {
    formData.append('avatar', avatarFile);
  }
  
  return formData;
};

/**
 * Validerar avatar-fil
 * @param {File} file - Avatar-filen
 * @returns {Object} { isValid, error }
 */
export const validateAvatarFile = (file) => {
  if (!file) {
    return { isValid: false, error: 'Ingen fil vald' };
  }
  
  if (!file.type.startsWith('image/')) {
    return { isValid: false, error: 'Endast bildfiler är tillåtna' };
  }
  
  const maxSize = 1024 * 1024; // 1MB
  if (file.size > maxSize) {
    return { isValid: false, error: 'Bilden får inte vara större än 1MB' };
  }
  
  return { isValid: true, error: null };
};

